export const EventConstants = {
  PAGE_CHANGE: "PAGE_CHANGE",
  SELECT: "SELECT",
  UNSELECT: "UNSELECT",
  SORT: "SORT",
  LAZY_LOAD: "LAZY_LOAD",
};
